import { AutomationConditionDataValue } from './automation-triggers.types';

export enum AutomationConditionType {
  CandidateHired = 'candidate_hired',
  CandidateHasTask = 'candidate_has_task',
  CandidateTasksCompleted = 'candidate_tasks_completed',
  CandidateOverdue = 'candidate_overdue',
  CandidateHasNote = 'candidate_has_note',
  CandidateEventOrganizer = 'candidate_event_organizer',
  CandidatePreferredLocation = 'candidate_preferred_location',
  JobLocation = 'offer_location',
  JobDepartment = 'offer_department',
  JobRecruiter = 'offer_recruiter',
  JobHiringManager = 'offer_hiring_manager',
}

export type AutomationCondition = {
  name: string;
  type: AutomationConditionType;
  data: Array<{
    name: string;
    selectedOption?: {
      label: string;
      value: AutomationConditionDataValue;
    };
    selectedOptions?: Array<{
      label: string;
      value: AutomationConditionDataValue;
    }>;
  }>;
};

export type AutomationDescriptionCondition = {
  type: AutomationConditionType | null;
  data: Array<{
    name: string;
    selectedOption?: {
      label: string;
      value: AutomationConditionDataValue;
    };
    selectedOptions?: Array<{
      label: string;
      value: AutomationConditionDataValue;
    }>;
  }>;
};
